// extracted by mini-css-extract-plugin
module.exports = {"description":"ModalReason_description__18kdi","options":"ModalReason_options__1nYtZ","option":"ModalReason_option__1tE20"};